






















import { Vue, Component } from 'vue-property-decorator';
import { NavigationPanel } from '@/components';
import { mapGetters, mapActions } from 'vuex';

@Component({
  name: 'ToRenters',
  components: {
    NavigationPanel,
  },
  created(): void {
    this.fetchTranslation();
  },
  data() {
    return {
      height: 310,
    };
  },
  computed: {
    ...mapGetters(['navigation']),
    ...mapGetters('renters', ['headerBgImg', 'callBack']),

    tabs() {
      if (this.navigation) {
          const nav = this.navigation.filter((tab) => {
          return tab.name === 'toRenters';
        });
          return nav && !!nav.length ? nav[0].children : [];
      }
    },
  },
  methods: {
    ...mapActions('renters', ['fetchTranslation']),
  },
})
export default class ToRenters extends Vue {}
